export default "__VITE_ASSET__DXbpkpe6__"